module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "mode": "out-in"
    },
    on: {
      "enter": _vm.enter,
      "before-leave": _vm.beforeLeave
    }
  }, [(_vm.localActive || !_vm.lazy) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localActive || _vm.lazy),
      expression: "localActive || lazy"
    }],
    ref: "panel",
    staticClass: "tab-pane",
    class: [{
      show: _vm.show,
      fade: _vm.fade,
      disabled: _vm.disabled,
      active: _vm.localActive
    }],
    attrs: {
      "role": "tabpanel"
    }
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7279cf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/tab.vue
// module id = 262
// module chunks = 0